import { useState } from 'react'
import { rememberDismissal, useTermsStatus, wasDismissedThisSession } from '@/features/terms/api'
import { TermsDialog } from '@/features/terms/TermsDialog'
import { termsVersion } from '@/features/terms/content'

export function TermsEntryPrompt() {
  const terms = useTermsStatus()
  const [dismissed, setDismissed] = useState(() => wasDismissedThisSession(termsVersion))

  const open = terms.data?.accepted === false && !dismissed

  return (
    <TermsDialog
      open={open}
      onAccepted={() => {
        setDismissed(true)
      }}
      onDeclined={() => {
        rememberDismissal(termsVersion)
        setDismissed(true)
      }}
    />
  )
}
